const SET_ROUTE_SPEED_COLOR = "SET_ROUTE_SPEED_COLOR";

const setRouteSpeedColorAction = (data) => {
  return {
    type: SET_ROUTE_SPEED_COLOR,
    data,
  };
};

const setRouteSpeedColor = (data) => {
  return (dispatch) => {
    dispatch(setRouteSpeedColorAction(data));
  };
};

export { SET_ROUTE_SPEED_COLOR, setRouteSpeedColor };
